import { ICopyable } from '../controls/common/icopyable';
import { IParams } from './interfaces/params.interface';

export class Params implements ICopyable<Params> {
    public id: number = null;
    public name: string = null;
    public type: string = null;
    public groupName: string = null;
    public defaultValue: string = null;

    public createCopy(): Params {
        const instance = new Params();
        instance.id = this.id;
        instance.name = this.name;
        instance.type = this.type;
        instance.groupName = this.groupName;
        instance.defaultValue = this.defaultValue;
        return instance;
    }

    public static createFormCopy(params: Params): IParams {
        const instance = new Params();
        instance.id = params.id;
        instance.name = params.name;
        instance.type = params.type;
        instance.groupName = params.groupName;
        instance.defaultValue = params.defaultValue;
        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.type = other.type;
        this.groupName = other.groupName;
        this.defaultValue = other.defaultValue;
    }

    /**
     * Retourne une instance de Params à partir d'une instance de IParams.
     * @param other : Instance de IParams.
     * @returns : Instance de Params.
     */
    public static from(other: IParams) {
        if (!!other) {
            const instance = new Params();

            instance.id = other.id;
            instance.name = other.name;
            instance.type = other.type;
            instance.groupName = other.groupName;
            instance.defaultValue = other.defaultValue;

            return instance;
        } else {
            return null;
        }
    }

    public getDisplayName() {
        return `${this.name}`;
    }
}
